import {useEffect, useState} from 'react';
import {ChecklistsFactory} from '../../checklists/store/checklistsFactory';
import {VisitChecklistSubmission} from '../../checklists/models/checklist.model';
import {AppError} from '../../../Data/config/AppError';

interface UseVisitChecklistSubmissionsReturn {
  submissions: VisitChecklistSubmission[];
  loading: boolean;
  error: string | null;
}

/**
 * Load the checklists filled during a visit (CR09 Phase 2). Fetches only when
 * [enabled] (the checklists module is on) and a [visitId] is provided. Mirrors
 * the visits feature's manual-fetch hook style (see useVisitProductDetails) and
 * routes through the checklists clean-arch chain via the factory.
 */
export function useVisitChecklistSubmissions (
  visitId: number | null,
  enabled: boolean
): UseVisitChecklistSubmissionsReturn {
  const [submissions, setSubmissions] = useState<VisitChecklistSubmission[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || visitId == null) {
      setSubmissions([]);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    ChecklistsFactory.createListVisitSubmissionsUseCase()
      .execute(visitId)
      .then(result => {
        if (!cancelled) {
          setSubmissions(result);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err instanceof AppError ? err.message : 'حدث خطأ في جلب نتائج قوائم التحقق');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [visitId, enabled]);

  return {submissions, loading, error};
}
